import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    // flex: 1,
  },
  loading:{
    // flex:1,
    flexDirection:'column',
    justifyContent:'center',
    marginTop:200,
  }
});
